import {
  PREFERENCES_REQUEST,
  PREFERENCES_WITHOUT_SITES_REQUEST,
  UPDATE_PREFERENCES_REQUEST,
  GET_USER_OWN_PREFERENCES_REQUEST,
  SET_SOLARGRAF_ACCESS
} from './constants';

export function getUserPreferences(payload) {
  return { type: PREFERENCES_REQUEST, payload };
}

export function getUserPreferencesWithoutSites(payload) {
  return { type: PREFERENCES_WITHOUT_SITES_REQUEST, payload };
}

export function updateUserPreferences(payload) {
  return { type: UPDATE_PREFERENCES_REQUEST, payload };
}

export function getUserOwnPreferences() {
  return { type: GET_USER_OWN_PREFERENCES_REQUEST };
}

export function setSolargrafAccess(solargrafAccess) {
  return { type: SET_SOLARGRAF_ACCESS, solargrafAccess };
}
